module.exports = __webpack_public_path__ + "static/Fairmarket-User-Agreement-9f2dddb257b4371aba1e8fa95d0f5100.pdf";